<template>
  <div class="public-product-posting-detail">
    <div v-if="isLoading" class="loading-container">
      <b-spinner variant="primary"></b-spinner>
      <p class="mt-2">Đang tải thông tin...</p>
    </div>
    
    <div v-else-if="postingData" class="posting-container">
      <!-- Header with title and back button -->
      <div class="posting-header">
        
        
        <h1 class="posting-title">{{ getPostingTitle() }}</h1>
        
        <div class="posting-tags mt-3">
            <b-badge variant="warning" class="mr-2"  v-if="productData && productData.status">{{ productData.status }}</b-badge>
            
          <b-badge variant="primary" class="mr-2" v-if="productData && productData.structure">{{ productData.structure }}</b-badge>
          <b-badge variant="info" class="mr-2" v-if="productData && productData.area">{{ productData.area }} m²</b-badge>
          
        </div>
      </div>

      <!-- Main content -->
      <div class="row">
        <!-- Left column - Posting content and property details -->
        <div class="col-lg-12 col-md-12">
          <!-- Property Details Section (if product data exists) - MOVED UP -->
          <div class="property-details-card mb-4" v-if="productData">
            <div class="section-header">
              <h3 class="section-title">
                🏠 Thông tin bất động sản
              </h3>
            </div>

             <!-- Posting content text -->
             <div class="" v-if="postingData.content">
                <div class="content-text">{{ postingData.content }}</div>
              </div>
            
          </div>

          <!-- Posting Content Section -->
          <div class="posting-content-section mb-4">
            <div class="content-card">

              <!-- Main posting video (thumbnail, not playable inline) -->
              <div class="posting-main-video mb-4" v-if="firstVideo && firstVideo.url" @click="openMedia(firstVideo)">
                <video
                  :src="firstVideo.url"
                  class="main-posting-video no-interact"
                  preload="metadata"
                  playsinline
                  muted
                ></video>
                <div class="video-overlay">
                  <b-icon icon="play-fill" class="play-icon-lg"></b-icon>
                </div>
              </div>

              <!-- Main posting image -->
              <div class="posting-main-image mb-4" v-if="hasMainImage">
                <img 
                  :src="postingData.content_img_url" 
                  class="main-posting-image"
                  @click="openMedia({type: 'image', url: postingData.content_img_url})"
                />
                <div class="image-overlay">
                  <b-button variant="light" size="sm" @click="openMedia({type: 'image', url: postingData.content_img_url})">
                    <b-icon icon="zoom-in"></b-icon> Xem toàn màn hình
                  </b-button>
                </div>
              </div>

             
              <!-- Additional media from JSON - CHANGED TO VERTICAL LAYOUT -->
              <div class="additional-media mt-4" v-if="mediaGridItems && mediaGridItems.length > 0">
                <div class="media-vertical-list">
                  <div 
                    v-for="(m, index) in mediaGridItems" 
                    :key="index"
                    class="media-item-vertical mb-4"
                    @click="openMedia(m)"
                  >
                    <template v-if="m.type==='video'">
                      <div class="video-thumb-vertical" >
                        <video :src="m.url" class="thumb-video-vertical no-interact" preload="metadata" playsinline muted></video>
                        <div class="video-overlay">
                          <b-icon icon="play-fill" class="play-icon-lg"></b-icon>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <img :src="m.url" :alt="`Hình ảnh ${index + 1}`" class="image-vertical" />
                    </template>
                  </div>
                </div>
              </div>

              <!-- Product URL link -->
              <!-- <div class="product-link mt-4" v-if="hasProductLink">
                <h4>🔗 Liên kết gốc</h4>
                <b-button 
                  :href="postingData.product_url" 
                  target="_blank" 
                  variant="outline-primary"
                  size="sm"
                >
                  <b-icon icon="box-arrow-up-right"></b-icon> Xem tin gốc
                </b-button>
              </div> -->
            </div>
          </div>
        </div>

        
      </div>
    </div>

    <div v-else class="error-container">
      <b-icon icon="exclamation-triangle" font-scale="3" variant="warning"></b-icon>
      <h3 class="mt-3">Không tìm thấy tin đăng</h3>
      <p>Tin đăng này có thể đã được gỡ bỏ hoặc không tồn tại.</p>
      <b-button variant="primary" @click="goBack">Quay lại</b-button>
    </div>

    <!-- Media Modal -->
    <b-modal v-model="showImageModal" size="xl" hide-footer centered>
      <template #modal-header>
        <h5 class="modal-title">Xem media</h5>
        <button type="button" class="close" @click="showImageModal = false">
          <span>&times;</span>
        </button>
      </template>
      <div class="modal-image-container">
        <img :src="selectedImage" class="modal-image" v-if="modalMedia && modalMedia.type==='image' && selectedImage" />
        <video v-else-if="modalMedia && modalMedia.type==='video'" :src="modalMedia.url" class="modal-video" controls playsinline></video>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ProductPostingService from '@/module-product-posting/ProductPostingService'
import ProductService from '@/services/productService'
import axios from 'axios'
import Constants from '@/constants'
import moment from 'moment'

export default {
  name: 'PublicProductPostingViewDetail',
  metaInfo() {
    const title = this.getMetaTitle()
    const description = this.getMetaDescription()
    const image = this.getMetaImage()
    const url = this.getMetaUrl()
    
    return {
      title: title,
      meta: [
        // Basic meta tags
        { name: 'description', content: description },
        { name: 'keywords', content: 'bất động sản, nhà đất, mua bán, cho thuê, LXL Atlas' },
        
        // Open Graph tags for Facebook, LinkedIn, etc.
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:image', content: image },
        { property: 'og:url', content: url },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'LXL Atlas - Bất động sản' },
        
        // Twitter Card tags
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: image },
        
        // Additional meta tags for better sharing
        { name: 'author', content: 'LXL Atlas' },
        { property: 'og:locale', content: 'vi_VN' },
        { name: 'robots', content: 'index, follow' }
      ]
    }
  },
  data() {
    return {
      postingData: null,
      productData: null,
      postingMedia: [],
      mediaGridItems: [],
      firstVideo: null,
      modalMedia: null,
      isLoading: true,
      contactForm: {
        fullname: '',
        phone: '',
        needs_contact: ''
      },
      isSubmitting: false,
      submitted: false,
      showImageModal: false,
      selectedImage: null
    }
  },
  async mounted() {
    await this.loadPostingData()
  },
  computed: {
    hasMainImage() {
      return this.postingData && this.hasValue(this.postingData.content_img_url)
    },
    hasProductLink() {
      return this.postingData && this.hasValue(this.postingData.product_url)
    }
  },
  methods: {
    hasValue(v) {
      return typeof v === 'string' && v.trim().length > 0
    },

    // Extract first video URL from a media payload (JSON string or object)
    extractFirstVideo(mediaPayload) {
      if (!mediaPayload) return null
      let media
      try {
        media = typeof mediaPayload === 'string' ? JSON.parse(mediaPayload) : mediaPayload
      } catch (e) {
        return null
      }
      if (!media || typeof media !== 'object') return null
      // direct 'video' field
      if (this.hasValue(media.video)) return { type: 'video', url: media.video }
      // find by conventional keys or any string URL that looks like a video
      const candidates = []
      Object.keys(media).forEach(k => {
        const v = media[k]
        if (Array.isArray(v)) {
          v.filter(u => this.hasValue(u)).forEach(u => candidates.push(u))
        } else if (this.hasValue(v)) {
          candidates.push(v)
        }
      })
      const videoUrl = candidates.find(u => /\.(mp4|webm|mov)$/i.test(u)) || null
      return videoUrl ? { type: 'video', url: videoUrl } : null
    },
    async loadPostingData() {
      console.log('🔍 [loadPostingData] Starting function execution...')
      
      try {
        this.isLoading = true
        const postingId = this.$route.params.postingId
        const productId = this.$route.params.productId
        
        console.log('📋 [loadPostingData] Route params:', {
          postingId,
          productId,
          fullRoute: this.$route.params
        })
        
        if (!postingId) {
          console.warn('⚠️ [loadPostingData] No postingId found in route params')
          this.postingData = null
          return
        }

        console.log('🔍 [loadPostingData] Attempting to load posting data for ID:', postingId)

        // Load posting data
        const postingService = new ProductPostingService()
        console.log('📡 [loadPostingData] Calling postingService.getDetail()...')
        
        let postingData = await postingService.getDetail(postingId)
        console.log('📦 [loadPostingData] Initial posting data result:', {
          found: !!postingData,
          data: postingData ? {
            id: postingData.id,
            product_id: postingData.product_id,
            content: postingData.content,
            media: postingData.media,
            content_img_url: postingData.content_img_url ? 'URL present' : null,
            created_at: postingData.created_at
          } : null
        })
        
        // If not found in the main table, try the product_posting_2 table
        if (!postingData) {
          console.log('🔍 [loadPostingData] Posting not found in main table, trying product_posting_2...')
          try {
            const query = `SELECT * FROM realestate.product_posting_2 WHERE id=${postingId}`
            const url = Constants.HOST_URL + 'runSelectQuery?query=' + encodeURIComponent(query)
            
            console.log('📡 [loadPostingData] Querying product_posting_2 with URL:', url)
            console.log('📡 [loadPostingData] Raw query:', query)
            
            const response = await axios.get(url)
            console.log('📦 [loadPostingData] product_posting_2 response:', {
              status: response.status,
              dataLength: response.data ? response.data.length : 0,
              hasData: !!(response.data && response.data.length > 0)
            })
            
            if (response.data && response.data.length > 0) {
              postingData = response.data[0]
              console.log('✅ [loadPostingData] Found posting in product_posting_2:', {
                id: postingData.id,
                product_id: postingData.product_id,
                content: postingData.content ? `${postingData.content.substring(0, 100)}...` : null,
                media: postingData.media ? 'JSON data present' : null,
                content_img_url: postingData.content_img_url ? 'URL present' : null,
                created_at: postingData.created_at
              })
            } else {
              console.warn('⚠️ [loadPostingData] No data found in product_posting_2 table')
            }
          } catch (error) {
            console.error('❌ [loadPostingData] Error querying product_posting_2:', {
              error: error.message,
              status: error.response?.status,
              statusText: error.response?.statusText,
              data: error.response?.data
            })
          }
        }
        
        if (postingData) {
          console.log('✅ [loadPostingData] Setting posting data and processing media...')
          this.postingData = postingData
          
          // Try to detect the first video as early as possible (before media processing)
          try {
            this.firstVideo = this.extractFirstVideo(postingData.media)
            console.log('🎬 [loadPostingData] firstVideo detected:', this.firstVideo)
          } catch (e) {
            console.warn('⚠️ [loadPostingData] Unable to extract first video:', e && e.message)
          }

          console.log('🖼️ [loadPostingData] Processing media for posting...')
          this.processPostingMedia(postingData)
          
          // Load associated product data if available
          const targetProductId = productId || postingData.product_id
          if (targetProductId) {
            console.log('🔍 [loadPostingData] Loading associated product data for ID:', targetProductId)
            try {
              const productService = new ProductService()
              const productData = await productService.getDetail(targetProductId)
              console.log('📦 [loadPostingData] Product data result:', {
                found: !!productData,
                data: productData ? {
                  id: productData.id,
                  code: productData.code,
                  fullname: productData.fullname,
                  street: productData.street,
                  price: productData.price,
                  priceForRent: productData.priceForRent
                } : null
              })
              this.productData = productData
            } catch (productError) {
              console.error('❌ [loadPostingData] Error loading product data:', {
                productId: targetProductId,
                error: productError.message,
                status: productError.response?.status
              })
            }
          } else {
            console.warn('⚠️ [loadPostingData] No product ID available for loading product data')
          }
        } else {
          console.warn('⚠️ [loadPostingData] No posting data found after all attempts')
          this.postingData = null
        }
        
        console.log('✅ [loadPostingData] Function completed successfully')
        
      } catch (error) {
        console.error('❌ [loadPostingData] Critical error in function:', {
          error: error.message,
          stack: error.stack,
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data
        })
        this.postingData = null
      } finally {
        console.log('🏁 [loadPostingData] Setting isLoading to false')
        this.isLoading = false
      }
    },

    processPostingMedia(data) {
      console.log('🖼️ [processPostingMedia] Starting media processing...')
      console.log('📦 [processPostingMedia] Input data:', {
        hasMedia: !!data.media,
        mediaType: typeof data.media,
        mediaLength: data.media ? data.media.length : null,
        contentImgUrl: data.content_img_url ? 'URL present' : null
      })
      
      this.postingMedia = []
      this.mediaGridItems = []
      this.firstVideo = null
      
      if (data.media) {
        console.log('🔍 [processPostingMedia] Processing media data...')
        try {
          const mediaData = typeof data.media === 'string' 
            ? JSON.parse(data.media) 
            : data.media
          
          console.log('📦 [processPostingMedia] Parsed media data:', {
            type: typeof mediaData,
            isArray: Array.isArray(mediaData),
            isObject: typeof mediaData === 'object',
            keys: typeof mediaData === 'object' ? Object.keys(mediaData) : null,
            rawData: mediaData
          })
          
          if (Array.isArray(mediaData)) {
            console.log('📋 [processPostingMedia] Processing as array...')
            this.postingMedia = mediaData.filter(url => 
              url && typeof url === 'string' && url.trim().length > 0
            )
            // Build grid items (images only from array format)
            this.mediaGridItems = this.postingMedia.map(url => ({ type: 'image', url }))
            console.log('✅ [processPostingMedia] Array processing result:', {
              originalLength: mediaData.length,
              filteredLength: this.postingMedia.length,
              urls: this.postingMedia
            })
          } else if (typeof mediaData === 'object') {
            console.log('📋 [processPostingMedia] Processing as object...')
            // Handle object format
            const allUrls = Object.values(mediaData).flat()
            console.log('📦 [processPostingMedia] Extracted URLs from object:', {
              objectKeys: Object.keys(mediaData),
              allUrls: allUrls
            })
            
            this.postingMedia = allUrls.filter(url => url && typeof url === 'string' && url.trim().length > 0)

            // Handle new format with arrays
            let images = []
            
            // Handle new images array format
            if (mediaData.images && Array.isArray(mediaData.images)) {
              images = mediaData.images
                .filter(u => this.hasValue(u))
                .map(u => ({ type: 'image', url: u }))
            } else {
              // Legacy format: img1, img2, img3
              images = ['img1','img2','img3']
                .map(k => mediaData[k])
                .filter(u => this.hasValue(u))
                .map(u => ({ type: 'image', url: u }))
            }
            
            // Handle videos - check new videos array or legacy video field
            let videoUrl = null
            if (mediaData.videos && Array.isArray(mediaData.videos) && mediaData.videos.length > 0) {
              videoUrl = mediaData.videos.find(u => this.hasValue(u))
            } else if (this.hasValue(mediaData.video)) {
              videoUrl = mediaData.video
            }
            
            if (videoUrl) {
              this.firstVideo = { type: 'video', url: videoUrl }
            }
            
            // Handle other keys (for backward compatibility)
            Object.keys(mediaData).forEach(k => {
              if (!['video','img1','img2','img3','images','videos'].includes(k)) {
                const v = mediaData[k]
                if (Array.isArray(v)) {
                  v.filter(u => this.hasValue(u)).forEach(u => images.push({ type: 'image', url: u }))
                } else if (this.hasValue(v)) {
                  images.push({ type: 'image', url: v })
                }
              }
            })
            this.mediaGridItems = images
            console.log('✅ [processPostingMedia] Object processing result:', {
              originalUrls: allUrls.length,
              filteredLength: this.postingMedia.length,
              urls: this.postingMedia,
              firstVideo: this.firstVideo,
              gridCount: this.mediaGridItems.length
            })
          } else {
            console.warn('⚠️ [processPostingMedia] Unexpected media data type:', typeof mediaData)
          }
        } catch (e) {
          console.error('❌ [processPostingMedia] Error parsing posting media:', {
            error: e.message,
            stack: e.stack,
            rawMedia: data.media
          })
        }
      } else {
        console.log('ℹ️ [processPostingMedia] No media data found in posting')
      }
      
      console.log('🏁 [processPostingMedia] Final media:', {
        imagesLength: this.mediaGridItems.length,
        firstVideo: this.firstVideo,
        imageUrls: this.mediaGridItems
      })
    },

    formatPrice(price) {
      if (!price) return ''
      const numPrice = parseFloat(price)
      if (numPrice >= 1000) {
        return (numPrice / 1000).toFixed(1)
      }
      return numPrice.toLocaleString('vi-VN')
    },

    formatDate(dateString) {
      if (!dateString) return ''
      return moment(dateString).format('DD/MM/YYYY HH:mm')
    },

    goBack() {
      this.$router.go(-1)
    },

    openImageModal(image) {
      this.selectedImage = image
      this.showImageModal = true
    },

    openMedia(media) {
      if (!media || !media.url) return
      this.modalMedia = media
      if (media.type === 'image') {
        this.selectedImage = media.url
      } else {
        this.selectedImage = null
      }
      this.showImageModal = true
    },

    getPostingTitle() {
      if (this.postingData && this.postingData.content) {
        // Extract first line or first 100 characters as title
        const firstLine = this.postingData.content.split('\n')[0]
        if (firstLine.length > 100) {
          return firstLine.substring(0, 97) + '...'
        }
        return firstLine
      }
      
      // Fallback title with product info if available
      if (this.productData) {
        let title = 'Tin đăng '
        if (this.productData.type) title += this.productData.type + ' '
        if (this.productData.area) title += this.productData.area + 'm² '
        if (this.productData.district) title += 'tại ' + this.productData.district
        return title
      }
      
      return 'Tin đăng bất động sản'
    },

    async onSubmit(event) {
      event.preventDefault()
      
      if (this.isSubmitting) return
      
      this.isSubmitting = true
      
      try {
        // Use the same structure as existing contact forms
        const columns = ['code', 'fullname', 'phone', 'needs_contact', 'created_at', 'input_by', 'sale', 'source', 'status', 'created_by']
        const values = [
          `'KH${moment().format('YYMMDD-HHmmss')}'`,
          `'${this.contactForm.fullname}'`,
          `'${this.contactForm.phone}'`,
          `'${this.contactForm.needs_contact} - Quan tâm tin đăng ID: ${(this.postingData && this.postingData.id) || this.$route.params.postingId}'`,
          `'${moment().format('YYYY-MM-DD HH:mm:ss')}'`,
          `'PUBLIC_USER'`,
          `'TUẤN'`,
          `'optin form tin đăng angiangnhadat'`,
          `'Data mới'`,
          `'public_user'`
        ]

        const query = `INSERT INTO realestate.clients (${columns.join(',')}) VALUES (${values.join(',')})`
        
        const url = Constants.HOST_URL + 'runQuery/insert'
        await axios.post(url, { query })

        this.submitted = true
        
        // Reset form
        this.contactForm = {
          fullname: '',
          phone: '',
          needs_contact: ''
        }
      } catch (error) {
        console.error('Error submitting contact form:', error)
        alert('Có lỗi xảy ra khi gửi thông tin. Vui lòng thử lại.')
      } finally {
        this.isSubmitting = false
      }
    },

    // Meta tag helper methods
    getMetaTitle() {
      console.log('🔍 [getMetaTitle] Posting data:', this.postingData);
      console.log('🔍 [getMetaTitle] Product data:', this.productData);

      if (this.postingData && this.postingData.content) {
        const firstLine = this.postingData.content.split('\n')[0]
        const title = firstLine.length > 60 ? firstLine.substring(0, 57) + '...' : firstLine;

        console.log('🔍 [getMetaTitle] Title:', title);
        return `${title}` | `LXL Atlas`
      }
      
      if (this.productData) {
        let title = 'Bất động sản '
        if (this.productData.type) title += this.productData.type + ' '
        if (this.productData.area) title += this.productData.area + 'm² '
        if (this.productData.district) title += 'tại ' + this.productData.district

        console.log('🔍 [getMetaTitle] Title:', title);
        return `${title}` | `LXL Atlas`
      }
      
      return 'Sản phẩm bất động sản' | `LXL Atlas`
    },

    getMetaDescription() {
      if (this.postingData && this.postingData.content) {
        // Get first 155 characters for optimal description length
        const content = this.postingData.content.replace(/\n/g, ' ').trim()
        return content.length > 155 ? content.substring(0, 152) + '...' : content
      }
      
      if (this.productData) {
        let desc = 'Xem chi tiết bất động sản '
        if (this.productData.type) desc += this.productData.type + ' '
        if (this.productData.area) desc += `diện tích ${this.productData.area}m² `
        if (this.productData.price) desc += `giá ${this.formatPrice(this.productData.price)} tỷ `
        if (this.productData.district) desc += `tại ${this.productData.district}. `

        return desc
      }
      
      return 'Xem chi tiết tin đăng bất động sản tại LXL Atlas. Chuyên mua bán, cho thuê nhà đất uy tín.'
    },

    getMetaImage() {
      // Priority:  first media image > main posting image > fallback
      
      if (this.mediaGridItems && this.mediaGridItems.length > 0) {
        const firstImage = this.mediaGridItems.find(item => item.type === 'image')
        if (firstImage && firstImage.url) {
          return firstImage.url
        }
      }

      if (this.postingData && this.hasValue(this.postingData.content_img_url)) {
        return this.postingData.content_img_url
      }
      
      // Fallback to a default image
      return `${window.location.origin}/default-og-image.svg`
    },

    getMetaUrl() {
      return window.location.href
    }
  }
}
</script>

<style scoped>
.public-product-posting-detail {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px 0;
}

.loading-container, .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
}

.posting-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.posting-header {
  background: white;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  margin-bottom: 40px;
  text-align: center;
}

.header-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-button {
  border-radius: 25px;
  padding: 8px 16px;
  font-weight: 600;
}

.posting-date {
  background: #f8f9fa;
  padding: 8px 12px;
  border-radius: 20px;
}

.posting-title {
  font-size: 2.2rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 20px;
  line-height: 1.3;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.posting-tags .badge {
  font-size: 0.9rem;
  padding: 8px 12px;
}

/* Posting Content Styles */
.posting-content-section {
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  overflow: hidden;
}

.content-card {
  padding: 30px;
}

.posting-main-image {
  position: relative;
  height: 400px;
  overflow: hidden;
  cursor: pointer;
  border-radius: 10px;
}

.posting-main-video {
  position: relative;
  height: 400px;
  overflow: hidden;
  cursor: pointer;
  border-radius: 10px;
  background: #000;
}

.main-posting-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.main-posting-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.main-posting-image:hover {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 10px;
  right: 10px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.posting-main-image:hover .image-overlay {
  opacity: 1;
}

.video-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(0,0,0,0.15), rgba(0,0,0,0.35));
}

.posting-text {
  margin-bottom: 20px;
}

.content-text {
  /* background: #f8f9fa; */
  /* padding: 25px; */
  /* border-radius: 12px; */
  line-height: 1.7;
  white-space: pre-line;
  font-size: 1.1rem;
  /* border-left: 4px solid #007bff; */
  /* margin: 20px 0; */
}

.additional-media {
  margin-bottom: 20px;
}

/* Original grid layout (kept for backward compatibility) */
.media-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.media-item {
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.media-item:hover {
  transform: scale(1.05);
}

.media-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* New vertical layout */
.media-vertical-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 15px;
}

.media-item-vertical {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.media-item-vertical:hover {
  transform: scale(1.02);
}

.image-vertical {
  width: 100%;
  height: auto;
  min-height: 300px;
  object-fit: cover;
  display: block;
}

.video-thumb-vertical {
  width: 100%;
  height: 400px;
  background: #000;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}

.thumb-video-vertical {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumb-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Video thumbnail styling (static, no inline playback) */
.video-thumb {
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: #fff;
}

.video-thumb::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0,0,0,0.15), rgba(0,0,0,0.35));
}

.play-icon {
  font-size: 2.2rem;
  z-index: 1;
}

.play-icon-lg {
  font-size: 3rem;
  z-index: 1;
}

.main-video-thumb {
  height: 400px;
  border-radius: 10px;
}

.modal-video {
  max-width: 100%;
  max-height: 70vh;
  border-radius: 8px;
}

/* prevent video interaction for thumbnails */
.no-interact {
  pointer-events: none;
}

.property-details-card {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.section-header {
  padding-bottom: 15px;
  border-bottom: 2px solid #f8f9fa;
}

.section-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}

.property-specs {
  margin-bottom: 25px;
}

.spec-row {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #ecf0f1;
}

.spec-row:last-child {
  border-bottom: none;
}

.spec-icon {
  font-size: 1.2rem;
  margin-right: 10px;
  width: 25px;
}

.spec-label {
  font-weight: 600;
  color: #34495e;
  flex: 1;
}

.price-row {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border: none !important;
  margin: 15px 0;
}

.price-value {
  font-size: 1.2rem;
  font-weight: bold;
  color: #27ae60;
}

.description-content {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  line-height: 1.6;
  white-space: pre-line;
}

.contact-card {
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  position: sticky;
  top: 20px;
  margin-bottom: 20px;
}

.contact-title {
  color: #2c3e50;
  font-weight: bold;
  margin-bottom: 10px;
}

.contact-subtitle {
  color: #7f8c8d;
  margin-bottom: 20px;
  font-size: 0.9rem;
}

.form-label {
  font-weight: 600;
  color: #34495e;
  margin-bottom: 8px;
}

.required {
  color: #e74c3c;
}

.success-message {
  text-align: center;
  padding: 20px;
  color: #27ae60;
}

.posting-metadata-card {
  background: white;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.posting-metadata-card h5 {
  color: #2c3e50;
  margin-bottom: 15px;
}

.metadata-item {
  margin-bottom: 8px;
  font-size: 0.9rem;
}

/* Modal Styles */
.modal-image-container {
  text-align: center;
}

.modal-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .posting-container {
    padding: 0 15px;
  }
  
  .posting-header {
    padding: 25px 20px;
    margin-bottom: 25px;
  }
  
  .header-controls {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
    text-align: center;
  }
  
  .posting-date {
    align-self: center;
  }
  
  .posting-title {
    font-size: 1.6rem;
    margin-bottom: 15px;
  }
  
  .content-card,
  .property-details-card,
  .contact-card {
    padding: 20px;
  }
  
  .content-text {
    /* padding: 20px; */
    font-size: 1rem;
  }
  
  .spec-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .spec-label {
    min-width: auto;
    margin-bottom: 5px;
  }
  
  .contact-card {
    position: static;
    margin-top: 20px;
  }
  
  .posting-main-image {
    height: 250px;
  }
  
  .media-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 10px;
  }
  
  .media-item {
    height: 90px;
  }

  /* Mobile styles for vertical layout */
  .image-vertical {
    min-height: 200px;
  }

  .video-thumb-vertical {
    height: 250px;
  }
  
  .section-header {
    padding-bottom: 10px;
  }
}

/* Tablet styles */
@media (min-width: 769px) and (max-width: 992px) {
  .posting-main-image {
    height: 300px;
  }
}
</style>
